import React, { FC, ReactElement } from 'react';
import { DescriptionsItemProps } from '@firesoon/antd/lib/descriptions';
import { TextProps } from '../Text/interface';

interface ItemProps extends Omit<DescriptionsItemProps, 'children' | 'label'>, TextProps {}

/** 对外暴露Item承接，实际作用就是增加props */
const Item: FC<ItemProps> = ({ children }) => {
  return React.Children.only(children as ReactElement);
};

export default Item;
